
import hwAxios from '../../../rmsReduxStore/api-service/HWAxios';
import cache from '../../../rmsReduxStore/api-service/InMemoryCache';

import { AxiosResponse } from 'axios';
export class CachedAPI {
  baseUrl = process.env.REACT_APP_SERVER_BASE_URL_AC;

  fetchCacheFunction(apiUrl, cacheTime, key, forceCall?): Promise<AxiosResponse> {
    const fetchFunction = (): unknown => {
      const url = this.baseUrl + apiUrl;
      return hwAxios.get(url);
    };
    return cache.get(key, cache.CacheModule.refData, fetchFunction, cacheTime, forceCall); // 30 hours ttl.
  }
}

const cachedAPI = new CachedAPI();
export default cachedAPI;
